import { getResearchArticleIndexPath } from 'site-modules/editorial/utils/content-path';
import { pageDefinition } from 'site-modules/shared/pages/page';
import { getPageOptions } from 'site-modules/editorial/pages/research-article/research-article-definition';
import { ResearchDefault } from './research-default';

const pages = new Map();
export default ({ articleCategory, articleId, splat, chunkName }) => {
  const key = getResearchArticleIndexPath(articleCategory, articleId, splat);
  let page = pages.get(key);
  if (!page) {
    page = pageDefinition(
      getPageOptions({ articleCategory, articleId, splat, chunkName, pageTemplate: ResearchDefault })
    );
    pages.set(key, page);
  }
  return page;
};
